import { GlEmptyState } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import EMPTY_PIPELINE_SVG from '@gitlab/svgs/dist/illustrations/empty-state/empty-pipeline-md.svg?url';
import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
export default {
    name: 'PipelinesEmptyState',
    components: {
        GlEmptyState
    },
    mixins: [
        glSlotsMixin
    ],
    props: {
        title: {
            type: String,
            required: false,
            default: ''
        },
        description: {
            type: String,
            required: false,
            default: ''
        }
    },
    EMPTY_PIPELINE_SVG
};
